import React from 'react'

export const Loading = () => <p><em>Loading...</em></p>

export default Loading